/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
const MESSAGES = {
  APPLICATION_EMPTY_SCREEN_TITLE: "No Application to display",
  APPLICATION_ADD_BUTTON: "Add Application",
  NO_RESULTS_FOUND: "No results found",
  PLEASE_TRY_A_DIFFERENT_APPLICATION: "Please try a different Application",
  APPLICATION_TITLE: "Applications",
  COPIED_TO_CLIPBOARD: "Copied to clipboard",
  DELETE_APPLICATION_TITLE: "Are you sure you want to delete the Application ",
};

const TITLES = {
  EDIT: "Edit",
  CLONE: "Clone",
  DELETE: "Delete",
  CANCEL: "Cancel",
  APPLICATION_NAME: "Application Name",
  DELETE_APPLICATION: "Delete Application",
  APPLICATION_ID: "Application Id:",
  REALM_KEY: "Realm Key:",
  APPLICATION_ACCOUNT_KEY: "Account Key:",
};

export const PAGE_SIZE_APPLICATIONS = 1000;

export { MESSAGES, TITLES };
